

import { ref, Ref, defineComponent, watch } from 'vue';

import {darkMode} from '../globals';

export default defineComponent({
  name: 'InteractiveText',
  props: {
    content: [String, Array]
  },
  setup(props, context) {
    let tokens = ref<string[]>([]);
    watch(props, (after, before) => {
        if (typeof after.content === 'string') {
            tokens.value = [];
            let lines = after.content.split('\n');
            for (const line of lines) {
                tokens.value = [...tokens.value, ...line.split(' '), '\n'];
            }
        } else {
            tokens.value = [...(after.content as Array<string>)];
        }
    });

    return { 
        tokens,
        addToBuffer(event: Event, token: string) {
          event.preventDefault();
          context.emit('tokenSelect', token.trim().toLowerCase());
          return false;
        },
        darkMode
    };
  }
});
